import React from 'react';
import $ from 'jquery';
import { connect } from 'react-redux';
import { settingsRemoveImageFromCart, settingsNextStep} from '../../actions/settings';
import axios from 'axios';

class Cart extends React.Component {

  constructor(props) {
    super(props)
  }

  componentDidMount() {
    let csrfToken = document.getElementsByName('csrf-token')[0].getAttribute('content');
    axios.defaults.headers.common['X-CSRF-Token'] = csrfToken;
    window.addEventListener('click', function(evt) {
      if(evt.target.closest('.cart') == null && evt.target.closest('.cart-button') == null) {
        $('.cart').removeClass('active');
      }
    })
  }

  removeImage(index) {
    this.props.settingsRemoveImageFromCart(index);
  }

  onCartClose() {
    $('.cart').removeClass('active');
  }

  moneyFormat(amount) {
    amount = amount.toString();
    let moneyFormat = this.props.shop.data.money_format;
    if(moneyFormat.indexOf('amount_with_comma_separator') > -1) {
      // replace commas and decimals
      let amountNoCommas = amount.replaceAll(',', '*');
      let amountChangedDecimal = amountNoCommas.replaceAll('.', ',');
      amount = amountChangedDecimal.replaceAll('*', '.');
    }
    let formattedAmount = moneyFormat.replace(/\{\{(.+?)\}\}/g, amount);
    return formattedAmount;
  }

  onCheckout() {
    let _this = this;
    let items = this.props.settings.cart.map((image) => {
      let variantId = image.variantId.split('/')[image.variantId.split('/').length - 1]
      return(
        {
          quantity: 1,
          id: variantId
        }
      )
    })
    items.push.apply(items, this.props.settings.cart.map((image) => {
      if(image.frame != "" && image.frameVariant != "") {
        let frameId = image.frameVariant.split('/')[image.frameVariant.split('/').length - 1]
        return(
          {
            quantity: 1,
            id: frameId
          }
        )
      }
    }))
    let filteredItems = items.filter(function(el) {
      return el != null;
    })
    var url = "https://" + this.props.shop.shopify_domain + "/cart/add?"
    for(let i = 0; i < filteredItems.length; i++) {
      if(i == 0) {
        //url += "updates[" + filteredItems[i].id.toString() + "]=" + filteredItems[i].quantity.toString();
        url += "id[]=" + filteredItems[i].id.toString();
      } else {
        url += "&id[]=" + filteredItems[i].id.toString();
        //url += "&updates[" + filteredItems[i].id.toString() + "]=" + filteredItems[i].quantity.toString();
      }
    }
    console.log(url);
    window.location.replace(url);
    /*
    axios.post(url, {
      items: filteredItems
    })
    .then(function(response) {
      window.location.replace('https://' + _this.props.shop.shopify_domain + '/cart');
    })
    */
  }

  render() {
    let _this = this;
    let itemList = (<h4 className="cart__no-items text-center">{this.props.wallConfig.empty_cart}</h4>);
    let subtotal = "";
    if(this.props.settings.cart.length > 0) {
      subtotal = 0.0;
      itemList = this.props.settings.cart.map((item, index) => {
        let itemPrice;
        let sizeString = item.width.toString() + "x" + item.height.toString() + " cm";
        let currentFrame = this.props.wallConfig.cart_frame_text + ": None";
        subtotal += item.variantPrice + item.framePrice;
        if(item.frame != "" && item.frame != null) {
          for(let i=0; i<_this.props.frames.length; i++) {
            if(_this.props.frames[i].id == item.frame) {
              currentFrame = this.props.wallConfig.cart_frame_text + ": " + _this.props.frames[i].title;
            }
          }
        }
        return(
          <div className="cart__item d-flex">
            <div className="cart__item-image-wrapper col-4">
              <img className="cart__item-image" src={item.src} alt={item.alt} />
            </div>
            <div className="cart__item-meta col-8 d-flex flex-column justify-content-between">
              <div className="cart__item-info">
                <p className="cart__item-title">{item.alt.split(" -")[0]}</p>
                <p className="cart__item-size">{sizeString}</p>
                <p className="cart__item-frame">{currentFrame}</p>
                <p className="cart__item-subtotal">{this.moneyFormat(item.variantPrice + item.framePrice)}</p>
              </div>
              <p className="cart__item-remove" onClick={this.removeImage.bind(this, index)}>{this.props.wallConfig.cart_remove_text}</p>
            </div>
          </div>
        )
      })
    }
    let checkoutButton = "";
    let subtotalLine = "";
    if(this.props.settings.cart.length > 0) {
      checkoutButton = <button className="cart__checkout-button btn btn--primary btn--large" onClick={this.onCheckout.bind(this)}>{this.props.wallConfig.cart_atc_text}</button>
        subtotalLine = <h5 className="cart__subtotal-line d-flex justify-content-between">{this.props.wallConfig.cart_subtotal_text}: <span className="cart__subtotal-amount">{this.moneyFormat(subtotal)}</span></h5>
    }
    return(
      <div className="cart col-3 d-flex flex-column justify-content-between">
        <p className="cart__close" onClick={this.onCartClose.bind(this)}>X</p>
        <div className="cart__item-list">
          {itemList}
        </div>
        <div className="cart__checkout text-center">
          <div className="cart__subtotal px-3 py-3">
            {subtotalLine}
          </div>
          {checkoutButton}
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  shop: state.shop,
  wallConfig: state.wallConfig,
  settings: state.settings,
  products: state.products,
  frames: state.frames
})

const mapDispatchToProps = {
  settingsRemoveImageFromCart
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Cart);
